<svg
  width="16"
  height="16"
  viewBox="0 0 700 725"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M643.607 0H0V78.4245H643.607V0ZM579.936 139.302H63.5335V217.726H579.936V139.302ZM282.523 278.628H360.948V623.013H282.523V278.628ZM204.103 278.628H125.679V623.013H204.103V278.628ZM439.438 278.628H517.862V623.013H439.438V278.628Z"
    fill="currentColor"
  />
</svg>
